












import Vue from 'vue';

export default Vue.extend({
  props: {
    notActive: Boolean,
    notFullWidth: Boolean,
    showBackground: Boolean,
    leftAlign: Boolean,
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      if (this.notActive) {
        (this.$refs.btn as HTMLButtonElement).blur(); // hides blue rectangle
      }
    },
  },
});
